// sherlockjs (Neil Gupta's Sherlock, npm fork) — natural-language date/event parser.
// Used by ca/page/_todo_form_panel.php: `Sherlock.parse(text).startDate`.
// Exposed on window as the global `Sherlock` for that inline page script.
import Sherlock from 'sherlockjs';

export { Sherlock };
